import React, { useMemo } from 'react';
import { View } from 'react-native';
import Text from '../../../../../components/Text';

export enum ColumnType {
  'default',
  'header',
  'total',
}

interface ColumnProps {
  type: ColumnType;
  backgoundColor?: string;
  text: string;
}

const Column: React.FC<ColumnProps> = ({ type, backgoundColor, text }) => {
  const bgColor = useMemo(() => {
    if (backgoundColor) {
      return backgoundColor;
    }

    switch (type) {
      case ColumnType.header:
        return 'bg-gray-400';
      case ColumnType.total:
        return 'bg-feedback-neutral-textMain';
      default:
        return 'bg-light-100';
    }
  }, [backgoundColor, type]);

  const textColor =
    type !== ColumnType.default ? 'text-light-100' : 'text-gray-700';

  const horizontalPadding = type !== ColumnType.default ? 'px-8' : '';

  return (
    <View
      className={`${bgColor} ${horizontalPadding}  py-1 items-center justify-center`}
    >
      <Text className={`${textColor} text-xs`}>{text}</Text>
    </View>
  );
};

export default Column;
